import { render, staticRenderFns } from "./pharmacy-user.vue?vue&type=template&id=1979dbee&"
import script from "./pharmacy-user.vue?vue&type=script&lang=js&"
export * from "./pharmacy-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports